import { Action, ActionType } from "@redux/actionTypes/ksmRequirementActionType";
import { Reducer } from "react";

export interface IAPIKSMRequirementState {
  apiKSMRequirementDetailsByPID: IAPIKSMRequirementsDetailsByPID[];
}

export interface IAPIKSMRequirementsDetailsByPID {
  projectId: number;
  projectName: string;
  ksmData: ITableData;
  batchSizeData: ITableData;
  calculation?: ITableData;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: Record<string, any>[];
}

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}

const initialState = {
  apiKSMRequirementDetailsByPID: [],
};

export const ksmRequirementReducer: Reducer<IAPIKSMRequirementState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.KSM_REQUIREMENT_DETAILS_BY_PID:
      return {
        ...state,
        apiKSMRequirementDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
